<template >
    <div id="manageAsMember">
        <div class="mybreadcrumb">
            <div style="display:flex;align-items:center">
                <i class="iconfont icon-shouquan-tianchong" style="margin-right:10px;color:#999"></i>
                <el-breadcrumb separator-class="el-icon-arrow-right" >
                    <el-breadcrumb-item>授权管理</el-breadcrumb-item>
                    <el-breadcrumb-item>按成员</el-breadcrumb-item>
                    <el-breadcrumb-item>管理授权</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <button class="return-button" @click="returnClick">返回</button>
        </div>
        <div class="menber-info">
            <!-- <img :src="companypic" alt="" class="companypic"> -->
            <div class="companypic" v-if="!userHeadImageUrl">
                <i class="iconfont icon-jinglirenyuanwodeyonghu" style="color:#fff;font-size:40px"></i>
            </div>
            <div class="headpic" v-else>
                <img :src="userHeadImageUrl" style="border-radius:50%;width:80px;height:80px"/>
            </div>
            <div>
                <p>
                    <span class="commonwidth1 commonfz14-co99">手机号 :</span>
                    <span class="commonfz14-co33">{{phone}}</span>
                </p>
                <p class="common-matop">
                    <span class="commonwidth1 commonfz14-co99">姓名/企业昵称 :</span>
                    <span class="commonfz14-co33">{{realName}}</span>
                </p>
                
            </div>
            <div>
                <p>
                    <span class="commonfz14-co99">邀请时间 :</span>
                    <span class="commonfz14-co33">{{invitedAt}}</span>
                </p>
                <p class="common-matop">
                    <span class="commonfz14-co99 ">加入时间 :</span>
                    <span class="commonfz14-co33">{{addedAt}}</span>
                </p>
            </div>
            <div>
                <p class="departmentname">
                    <span class="commonwidth3 commonfz14-co99">部门 :</span>
                    <span class="commonfz14-co33 ">{{department}}</span>
                </p>
                <p class="common-matop">
                    <span class="commonwidth3 commonfz14-co99"></span>
                    <span class="commonfz14-co33"></span>
                </p>
            </div>
        </div>
        <div v-loading="memberloading" element-loading-text="数据加载中...">
            <div class="operate-box">
                <span>已分配授权信息</span>
                <div class="operate-right">
                    <el-button type="primary" class="operate-btn" @click="powerBtnclick">分配授权</el-button>
                    <el-button  class="operate-btn" @click="confirmMessage('cancle')" :disabled="cancleBtnDisable">取消分配</el-button>
                </div> 
            </div>
            <div style="padding:0 30px 30px 30px">
                <el-table
                :data="hasGrantTableData"
                border
                :header-cell-style="{color:'#333333',fontFamily:'MicrosoftYaHei',fontSize:'12px',fontWeight:400,padding:'9px 0',background:'#F5F5F5'}"
                style="width: 100%;"
                :cell-class-name="tabCellClassName"
                @selection-change="handleSelectionChange">
                <el-table-column
                type="selection"
                width="55"
                align="center"
                :selectable="hasGrantTableCanselect">
                </el-table-column>
                <el-table-column
                        label="序号"
                        type="index"
                        width="60"
                        align="center"
                        >
                    <template slot-scope="scope">
                        <span>{{(pageIndex-1) * pageSize + scope.$index + 1}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                prop="productName"
                label="产品名称"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="expirydate"
                label="有效期"
                width="230"
                align="center">
                </el-table-column>
                <el-table-column
                prop="grantedAt"
                label="分配时间"
                width="230"
                align="center">
                </el-table-column>
                <el-table-column
                prop="isActive"
                label="授权状态"
                width="105"
                align="center">
                    <template slot-scope="scope">
                        <div v-if="scope.row.snStatus==='正常'" class="table-status bgcgreen">
                                <span>{{scope.row.snStatus}}</span>
                            </div>
                            <div v-else-if="scope.row.snStatus==='禁用'||scope.row.snStatus==='已禁用'" class="table-status bgcred">
                                <span>{{scope.row.snStatus}}</span>
                            </div>
                            <div v-else-if="scope.row.snStatus==='过期'||scope.row.snStatus==='已过期'" class="table-status bgcorange">
                                <span>{{scope.row.snStatus}}</span>
                            </div>
                            <div v-else>
                                <span>{{scope.row.snStatus}}</span>
                            </div>
                    </template>
                </el-table-column>
            </el-table>
            </div>
        </div>
        <el-dialog
            title="分配授权"
            :visible.sync="emPowerDialog"
            width="800px"
            :close-on-click-modal="false">
            <div class="search-wraper">
                <el-input v-model="searchinput" placeholder="输入关键字搜索 ..." maxlength="100" @keyup.enter.native="searchClick"></el-input>
                <i class="el-icon-search search" @click="searchClick"></i>
            </div>
            <el-table
                :data="ProductListTableData"
                border
                :header-cell-style="{color:'#333333',fontFamily:'MicrosoftYaHei',fontSize:'12px',fontWeight:400,padding:'9px 0',background:'#F5F5F5'}"
                style="width: 100%;"
                :cell-class-name="tabCellClassName"
                @selection-change="grantSelectionChange"
                >
                <el-table-column
                type="selection"
                width="55"
                align="center"
                :selectable="ProductListTableCanselect">
                </el-table-column>
                <el-table-column
                        label="序号"
                        type="index"
                        width="60"
                        align="center"
                        >
                    <template slot-scope="scope">
                        <span>{{(pageIndex-1) * pageSize + scope.$index + 1}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                prop="productName"
                label="产品名称"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="expirationDate"
                label="有效期"
                width="160"
                align="center">
                </el-table-column>
                <el-table-column
                prop="unUsedSNCount"
                label="可用授权"
                width="80"
                align="center">
                </el-table-column>
                <el-table-column
                prop="isActive"
                label="授权状态"
                width="105"
                align="center">
                    <template slot-scope="scope">
                        <div v-if="scope.row.snStatus==='正常'" class="table-status bgcgreen">
                            <span>{{scope.row.snStatus}}</span>
                        </div>
                        <div v-else-if="scope.row.snStatus==='禁用'||scope.row.snStatus==='已禁用'" class="table-status bgcred">
                            <span>{{scope.row.snStatus}}</span>
                        </div>
                        <div v-else-if="scope.row.snStatus==='过期'||scope.row.snStatus==='已过期'" class="table-status bgcorange">
                            <span>{{scope.row.snStatus}}</span>
                        </div>
                        <div v-else>
                            <span>{{scope.row.snStatus}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="remarks"
                    label="备注"
                    show-overflow-tooltip
                    align="center">
                </el-table-column>
            </el-table>

            <div slot="footer">
                <el-button @click="emPowerDialog = false">取 消</el-button>
                <el-button type="primary" @click="confirmMessage('grant')" :disabled="empoerBtnDisable">确 定</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
import wenhaopng from '@/assets/img/companyuserpng/wenhao.png'
import duigoufill from '@/assets/img/companyuserpng/duigoufill.png'
import {GetUserInviteInfo,
        GetGrantSNProductInfo,
        GrantSNList,
        GrantSNToEnterpriseUser,
        CancelSN,
        BatchCancelSN,
        BatchGrantSNToEnterpriseUser,
        AdminGetUserHeadImageApi,
        BatchGrantSAASToEnterpriseUser,
        BatchCancelSAAS,
        GetUserSnInDepartmentApi} from '@/js/enterPriseApi'
import Moment from 'moment'
import  {BASE_URL} from "../../../../config/env";
import {MyZhugeTrackGoManagePage,MyZhugeTrackGrantSN,MyZhugeTrackCancleGrantSN} from '@/js/zhugemaidian.js' 
import {mydebounce} from '@/js/common.js'
export default {
    name:'MemberManage',
    data(){
        return{
            memberloading:false,
            companypic:require('../../../assets/img/wxzfbpay/phone.png'),
            wenhaopng,//问号图片
            duigoufill,//对勾图片
            tips:'success',
            searchinput:'',
            emPowerDialog:false,
            pageSize:10,
            pageIndex:1,
            total:0,
            status:"1",
            hasGrantTableData:[],
            ProductListTableData: [],
            multipleSelection: [],
            grantMultiselection:[],
            phone:'',
            realName:'',
            department:'',
            inviteStatus:'',
            invitedAt:'',
            addedAt:'',
            grantUserId:'',
            userHeadImageUrl:null,
        }
    },
    computed:{
        empoerBtnDisable(){
            if(this.grantMultiselection.length>0){
                return false;
            }else{
                return true;
            }
        },
        cancleBtnDisable(){
            if(this.multipleSelection.length>0){
                return false;
            }else{
                return true;
            }
        }

    },
    created(){
        let queryid=this.$route.query.userId;
        if(queryid){
            this.grantUserId=Number(atob(queryid));
            this.getInviteUserInfo(this.grantUserId);
            this.getGrantProductInfo(this.grantUserId);
            this.AdminGetUserHeadImage(this.grantUserId);
        }
    },
    mounted(){
        MyZhugeTrackGoManagePage({
            "管理方式":'按成员'
        })
    },
    methods:{
        tabCellClassName({row, column, rowIndex, columnIndex}){
            return 'cellstyle'
        },
        ProductListTableCanselect(row){//决定复选框是否可选
            return row.snStatus==='正常'
        },
        hasGrantTableCanselect(row){
            return row.snStatus==='正常'
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        grantSelectionChange(val){
            this.grantMultiselection = val;
        },
        confirmMessage(operatetype){//确认弹窗
            let that=this; 
            if(operatetype==='grant'){
               this.$confirm('您确定给该成员分配授权吗?', '提示信息', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                customClass: 'message-logout'
                }).then(() => {
                    //分配授权时候需要请求接口，
                    this.GetUserSnInDepartment()

                    //this.grantToUser()
                }).catch(() => {  

                });
           }else if(operatetype==='cancle'){
               this.$confirm('您确定要取消该成员的授权吗?', '提示信息', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                customClass: 'message-logout'
                }).then(() => {
                    let clientCount=0;
                    let saasCount=0;
                    that.multipleSelection.forEach(item=>{
                        if(item.productType==0){//客户端软件授权产品
                            clientCount++
                        }else if(item.productType==1){//SAAS授权产品
                            saasCount++
                        }
                    })
                    MyZhugeTrackCancleGrantSN({
                        "管理方式":'按成员'
                    })
                    if(clientCount){
                        that.cancleMemberSN()
                    }
                    if(saasCount){
                        let tip=true
                        if(clientCount){
                            tip=false
                        }
                        that.cancleSAASmenberSN(tip);
                    }

                }).catch(() => {  

                });
           }
        },
        GetUserSnInDepartment(){//授权时候，判断上级部门是否有授权
            let that=this
            let mainIds=[]
            this.grantMultiselection.forEach(item=>{
                mainIds.push(item.mainId)
            })
            let reqdata={
                enterPriseId:window.localStorage.getItem('enterPriseId'),
                userId:this.grantUserId,
                mainIds:mainIds
            }
            GetUserSnInDepartmentApi(reqdata)
            .then(res=>{
                if(res.status===200 && res.data.error_code===0){
                     const {data}=res.data;
                     this.grantConfirmTip(data)
                }else{
                    this.$message.error(res.data.error_msg)
                }
            })
            .catch(err=>{
                if(err.data && err.data.errorMessages){
                    that.$message.error(err.data.errorMessages[0]);
                }else if(err.data){
                    that.$message.error(err.data);
                }
            })
            
        },
        grantConfirmTip(data){
             if(data.typeNum===0){
               this.grantToUser()
            }else if(data.typeNum===1){//成员所在部门没有足够的授权
                this.$message.error(data.showMessage)
            }else if(data.typeNum===3){//成员所在部门和上级部门没有足够的授权
                this.$message.error(data.showMessage)
            }
            else if(data.typeNum===2){//成员所在部门没有授权，将从上级部门分配
                this.$confirm(data.showMessage, '提示信息', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    customClass: 'message-logout'
                }).then(() => {
                    this.grantToUser()
                })
                .catch(() => {  
                });
            } 
        },
        grantToUser(){
            let that=this
            let clientCount=0;
            let saasCount=0;
            that.grantMultiselection.forEach(item=>{
                if(item.productType==0){//客户端软件授权产品
                    clientCount++
                }else if(item.productType==1){//SAAS授权产品
                    saasCount++
                }
            })
            MyZhugeTrackGrantSN({
                "管理方式":'按成员'
            })
            if(clientCount){
                mydebounce(that.empowerBtnClick,800)();
            }
            if(saasCount){
                let tip=true
                if(clientCount){//当sass和客户端同时分配，不需要重复提示成功
                    tip=false
                }
                mydebounce(that.SAASempowerBtnClick,800)(tip);
            }
        },
        AdminGetUserHeadImage(userid){//企业管理员获取用户头像
            let that=this;
            AdminGetUserHeadImageApi({
                enterPriseId:window.localStorage.getItem('enterPriseId'),
                userId:this.grantUserId
            })
            .then(res=>{
                if(res.status===200 && res.data.error_code===0){
                    console.log(res)
                    const {data}=res.data;
                    if(data){
                        that.$nextTick(()=>{
                            that.userHeadImageUrl=null;
                            //阿里云oss地址
                            that.userHeadImageUrl=data
                            //that.userHeadImageUrl=BASE_URL.TEST_HOST_API+'/'+data;
                        })        
                    }
                }else{
                    if(res.data.error_msg==='用户未设置头像'){
                            console.log('用户未设置头像')
                        }else{
                            this.$message.error(res.data.error_msg)
                    }
                }
            })
            .catch(err=>{
                console.log(err)
                if(err.data && err.data.errorMessages){
                    that.$message.error(err.data.errorMessages[0]);
                }else if(err.data){
                    that.$message.error(err.data);
                }
            })
        },
        empowerBtnClick(tip){//授权分配dialog确定按钮点击
            
            let that=this;
            let params={
                grantUserId:that.grantUserId
            }
            let reqdata=[];
            that.grantMultiselection.forEach(item=>{
                if(item.productType==0){//挑选出客户端软件产品
                    reqdata.push(item.mainId);
                }   
            })
            BatchGrantSNToEnterpriseUser(params,reqdata)
            .then(res=>{
                console.log(res)
                if(res.status===200 && res.data.error_code===0){
                    const {data}=res.data;
                    if(data===true){
                        that.emPowerDialog=false;
                        that.$message.success('授权分配成功')
                        that.getGrantProductInfo(that.grantUserId);
                    }
                }else{
                  
                    that.$message.error(res.data.error_msg)
                }
            })
            .catch(err=>{
              
                console.log(err)
                if(err.data && err.data.errorMessages){
                    that.$message.error(err.data.errorMessages[0]);
                }else if(err.data){
                    that.$message.error(err.data);
                }
            })  
        },
        SAASempowerBtnClick(tip){//SAAS产品授权
            let that=this;
            let params={
                grantUserId:that.grantUserId
            }
            let reqdata=[];
            that.grantMultiselection.forEach(item=>{
                if(item.productType==1){//挑选出SAAS产品
                    reqdata.push(item.mainId);
                }   
            })
            BatchGrantSAASToEnterpriseUser(params,reqdata)
            .then(res=>{
                console.log(res)
                if(res.status===200 && res.data.error_code===0){
                    const {data}=res.data;
                    if(data===true){
                        that.emPowerDialog=false;
                        if(tip){
                            that.$message.success('授权分配成功')
                        }
                        that.getGrantProductInfo(that.grantUserId);
                    }
                }else{
                    
                    that.$message.error(res.data.error_msg)
                }
            })
            .catch(err=>{
                console.log(err)
                if(err.data && err.data.errorMessages){
                    that.$message.error(err.data.errorMessages[0]);
                }else if(err.data){
                    that.$message.error(err.data);
                }
            }) 
        },
        cancleMemberSN(){//取消一个成员某个产品的授权
            let that=this;
            let params={
                subId:that.multipleSelection[0].subId
            }
            let reqdata=[];
            that.multipleSelection.forEach(item=>{
                if(item.productType==0){//取消客户端软件授权
                    reqdata.push(item.subId)
                }
            })
            //CancelSN(params)
            BatchCancelSN(reqdata)
            .then(res=>{
                console.log(res)
                if(res.status===200 && res.data.error_code===0){
                    const {data}=res.data;
                    if(data===true){
                        that.$message.success('取消授权成功')
                        that.getGrantProductInfo(that.grantUserId);
                    }
                }else{
                    that.$message.error(res.data.error_msg)
                }
            })
            .catch(err=>{
                console.log(err)
                if(err.data && err.data.errorMessages){
                    that.$message.error(err.data.errorMessages[0]);
                }else if(err.data){
                    that.$message.error(err.data);
                }
            })
        },
        cancleSAASmenberSN(tip){//取消成员SAAS产品的授权
            let that=this;
            let params={
                subId:that.multipleSelection[0].subId
            }
            let reqdata=[];
            that.multipleSelection.forEach(item=>{
                if(item.productType==1){//取消SAAS授权
                    reqdata.push(item.subId)
                }
            })
            BatchCancelSAAS(reqdata)
            .then(res=>{
                console.log(res)
                if(res.status===200 && res.data.error_code===0){
                    const {data}=res.data;
                    if(data===true){
                        if(tip){
                            that.$message.success('取消授权成功')
                        }
                        that.getGrantProductInfo(that.grantUserId);
                    }
                }else{
                    that.$message.error(res.data.error_msg)
                }
            })
            .catch(err=>{
                console.log(err)
                if(err.data && err.data.errorMessages){
                    that.$message.error(err.data.errorMessages[0]);
                }else if(err.data){
                    that.$message.error(err.data);
                }
            })
        },
        getInviteUserInfo(userId){//获取已邀请成员的基本信息
            let that=this;
            let params={
                userId:userId,
                enterPriseId:{
                    enterPriseId:window.localStorage.getItem('enterPriseId')
                }
            }
            GetUserInviteInfo(params)
            .then(res=>{
                console.log(res)
                if(res.status===200 && res.data.error_code===0){
                    const {data}=res.data;
                    if(data){
                        that.phone=data.phone;
                        that.realName=data.realName;
                        that.department=data.department;
                        that.inviteStatus=data.inviteStatus;
                        that.invitedAt=data.invitedAt?Moment(data.invitedAt).format('YYYY-MM-DD HH:mm:ss'):'';
                        that.addedAt=data.addedAt?Moment(data.addedAt).format('YYYY-MM-DD HH:mm:ss'):'';
                    } 
                }else{
                    that.$message.error(res.data.error_msg)
                }
                   
            })
            .catch(err=>{
                console.log(err)
                if(err.data && err.data.errorMessages){
                    that.$message.error(err.data.errorMessages[0]);
                }else if(err.data){
                    that.$message.error(err.data);
                }
            })
        },
        getGrantProductInfo(userId){//获取个人已分配授权的产品信息
            let that=this;
            let params={
                userId:userId,
                enterPriseId:{
                    enterPriseId:window.localStorage.getItem('enterPriseId')
                }
            }
            this.memberloading=true;
            GetGrantSNProductInfo(params)
            .then(res=>{
                console.log(res)
                let that=this;
                if(res.status===200 && res.data.error_code===0){
                    let {data}=res.data;
                    that.hasGrantTableData=[];
                    data.forEach(item=>{
                        let obj={
                            productName:item.productName,
                            grantedAt:Moment(item.grantedAt).format('YYYY-MM-DD HH:mm:ss'),
                            expirydate:Moment(item.startAt).format('YYYY.MM.DD')+'-'+ Moment(item.endAt).format('YYYY.MM.DD'),
                            subId:item.subId,
                            isActive:item.hasOwnProperty('isActive')?item.isActive:'hasno',
                            snStatus:item.snStatus,
                            productType:item.productType,
                            licensingType:item.licensingType
                        }
                        if(obj.licensingType=='永久版'){
                            obj.expirydate='永久'
                        }
                        that.hasGrantTableData.push(obj);
                    })
                    this.memberloading=false;
                }else{
                    that.$message.error(res.data.error_msg)
                    this.memberloading=false;
                }
            })
            .catch(err=>{
                console.log(err)
                this.memberloading=false;
                if(err.data && err.data.errorMessages){
                    that.$message.error(err.data.errorMessages[0]);
                }else if(err.data){
                    that.$message.error(err.data);
                }
            })
        },
        returnClick(){
            let queryinfo=this.$route.query
            let obj={}
            if(queryinfo.pageSize){
                obj.pageSize=queryinfo.pageSize
                obj.pageIndex=queryinfo.pageIndex
            }
            this.$router.push({
                path:'/EmPowerAsMember',
                query:obj
            })
            
        },
        powerBtnclick(){//分配授权按钮点击
            this.emPowerDialog=true;
            this.ProductListTableData=[];
            this.getSNproductList({
                enterPriseId:window.localStorage.getItem('enterPriseId'),
                grantUserId:this.grantUserId
            });
        },
        getSNproductList(params){//获取该企业授权产品列表
            let that=this;
            GrantSNList(params)
            .then(res=>{
                console.log(res)
                if(res.status===200 && res.data.error_code===0){
                    const {data}=res.data;
                    that.ProductListTableData=[];
                    data.forEach(item=>{
                        let obj={
                            productName:item.productName,
                            mainId:item.mainId,
                            unUsedSNCount:item.unUsedSNCount,
                            allSNCount:item.allSNCount,
                            expirationDate:Moment(item.startAt).format('YYYY.MM.DD')+'-'+ Moment(item.endAt).format('YYYY.MM.DD'),
                            isActive:item.isActive,
                            snStatus:item.snStatus,
                            productType:item.productType,//0为客户端软件，1为SAAS产品
                            licensingType:item.licensingType,
                            remarks:item.remarks
                        }
                        if(obj.licensingType=='永久版'){
                            obj.expirationDate='永久'
                        }
                        that.ProductListTableData.push(obj);
                    })    
                }else{
                    that.$message.error(res.data.error_msg)
                }
            })
            .catch(err=>{
                console.log(err)
                if(err.data && err.data.errorMessages){
                    that.$message.error(err.data.errorMessages[0]);
                }else if(err.data){
                    that.$message.error(err.data);
                }
            })
        },
        searchClick(){//放大镜按钮点击
            if(this.searchinput){
                this.getSNproductList({
                    enterPriseId:window.localStorage.getItem('enterPriseId'),
                    searchCondition:this.searchinput,
                    grantUserId:this.grantUserId
                });
            }else{
                this.getSNproductList({
                    enterPriseId:window.localStorage.getItem('enterPriseId'),
                    grantUserId:this.grantUserId
                });
            }
        }
    }

}
</script>

<style lang="scss" scoped>
    #manageAsMember{
        background: #fff;
        /deep/ .el-breadcrumb{
            .el-breadcrumb__inner{
                font-family: MicrosoftYaHei;
                font-size: 12px;
                color: #666666;
                font-weight: 400;
            }
            .el-breadcrumb__separator{
                font-size: 12px !important;
                color: #666666;
            }
        }
        .mybreadcrumb{
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px 0 10px 20px;
            border-bottom: 1px solid #EAEAEA;
            .return-button{
                font-size: 12px;
                color: #666;
                font-family: MicrosoftYaHei;
                margin-right: 20px;
                width: 60px;
                height: 30px;
                background: #F6F6F6;
                border: 1px solid #E0E0E0;
                border-radius: 2px;
                line-height: 30px;
                cursor: pointer;
            }
        }
        .menber-info{
            margin: 20px 30px 0 30px;
            padding: 30px 0;
            display: flex;
            justify-content: space-around;
            align-items: center;
            text-align: left;
            .companypic{
                width: 80px;
                height: 80px;
                background-image: url('../../../assets/img/companyuserpng/bluepng.png');
                background-repeat: no-repeat;
                display:flex;
                justify-content: center;
                align-items: center;
            }
            
        }
        .operate-box{
            margin: 0 30px;
            overflow: hidden;
            position: relative;
            margin-bottom: 15px;
            .operate-right{
                float: right;
                .operate-btn{
                    font-size: 14px;
                    padding: 10px ;
                }
            }
            span{
                float: left;
                position: absolute;
                bottom: 0px;
                left: 0px;
                font-family: FZLTZHK--GBK1-0;
                font-size: 14px;
                color: #333333;
                font-weight: 600;
            }

        }
        .search-wraper{
            margin-bottom:20px;
            position: relative;
            display: flex;
            align-items:center;
            .search{
                position: absolute;
                left: 270px;
                font-size: 18px;
                cursor: pointer;
                color: rgb(200,200,200);
            }

        }
        .tips-wraper{
            padding: 20px 0 10px 0;
            display: flex;
            justify-content: center;
            align-items: center;
            .tip-text{
                margin-left: 20px;
            }
        }
        .table-status{
            span{
                margin-left: 8px;
            }
        }
        .bgcorange::before{
                content:'';
                width: 10px;
                height: 10px;
                border-radius: 50%;
                display: inline-block;
                background: #FE833D;
            }
        .bgcred::before{
                content:'';
                width: 10px;
                height: 10px;
                border-radius: 50%;
                display: inline-block;
                background: #fe3d3d;
            }
        .bgcgreen::before{
            content:'';
            width: 10px;
            height: 10px;
            border-radius: 50%;
            display: inline-block;
            background: #1DCB96;
        }
        //element-ui样式
        /deep/ .el-table .cellstyle{
            padding: 0;
            height: 40px;
            font-family: MicrosoftYaHei;
            font-size: 12px;
            color: #181818;
            font-weight: 400;
        }
        /deep/ .el-dialog{
            border-radius: 2px;
            width: 1000px;
            .el-dialog__header{
                background: #0069e0;
                text-align: left;
                padding: 15px 20px;
                .el-dialog__title{
                    font-family: MicrosoftYaHei;
                    font-size: 16px;
                    color: #FFFFFF;
                    font-weight: 400;
                }
                .el-dialog__close{
                    color: #fff;
                }
            }
            .el-input{
                width: 300px;
                
            }
        }
        //common样式
        .commonwidth1{
            display: inline-block;
            width: 100px;
        }
        .commonwidth3{
            display: inline-block;
            width: 50px;

        }
        .commonfz14-co99{
            font-family: MicrosoftYaHei;
            font-size: 14px;
            color: #999999;
            font-weight: 400;
        }
        .commonfz14-co33{
            font-family: MicrosoftYaHei;
            font-size: 14px;
            color: #333333;
            font-weight: 400;
        }
        .departmentname{
            max-width: 300px;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-all;
            white-space: nowrap;
            
        }
        .common-matop{
            margin-top: 15px;
        }
        
    }
    
</style>


// WEBPACK FOOTER //
// src/view/CompanyUser/EmPowerManage/manageAsMember.vue